import React, { useContext, useEffect, useState } from "react";
import { context } from "../../context/context";
import { FaBarsStaggered } from "react-icons/fa6";

const Header = () => {
  function processThemeChange() {
    const theme = localStorage.getItem("color-theme");
    if (theme) {
      if (theme === "dark") {
        document.documentElement.classList.add("dark");
        localStorage.setItem("color-theme", "dark");
      } else {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("color-theme", "light");
      }
    } else {
      if (document.documentElement.classList.contains("dark")) {
        console.log(document.documentElement.classList.contains("dark"));
        // document.documentElement.classList.remove('dark');
        localStorage.setItem("color-theme", "dark");
      } else {
        // document.documentElement.classList.add('light');
        localStorage.setItem("color-theme", "light");
      }
    }
  }

  const switchTheme = () => {
    const theme = localStorage.getItem("color-theme");
    if (theme) {
      if (theme === "light") {
        document.documentElement.classList.add("dark");
        localStorage.setItem("color-theme", "dark");
      } else {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("color-theme", "light");
      }
    }
  };

  useEffect(() => {
    processThemeChange();
  }, []);

  const { show, setShow, user } = useContext(context);

  console.log(user);

  return (
    <div className="sticky p-4 w-full top-0 z-[1010]">
      <div className="flex w-full h-16 justify-between drop-shadow-md shadow-md flex items-center bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 justify-end px-6 transition-all ease-linear rounded-3xl">
        <div className="flex gap-x-4 items-center text-gray-800 dark:text-white text-3xl">
          <FaBarsStaggered
            onClick={() => setShow(!show)}
            className="cursor-pointer lg:hidden"
          />

          <img src="" alt="" />
          <div className="flex gap-x-4 text-gray-800 dark:text-white">
            <button
              onClick={switchTheme}
              className="h-12 w-12 rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <svg
                className="fill-violet-700 block dark:hidden"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
              </svg>
              <svg
                className="fill-yellow-500 hidden dark:block"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <div className="flex items-center gap-4 text-gray-800 dark:text-white">
          <div>
            <h4>{user?.name}</h4>
            <p className="text-sm">{user?.role}</p>
          </div>
          <svg
            className="hidden fill-current sm:block"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.410765 0.910734C0.736202 0.585297 1.26384 0.585297 1.58928 0.910734L6.00002 5.32148L10.4108 0.910734C10.7362 0.585297 11.2638 0.585297 11.5893 0.910734C11.9147 1.23617 11.9147 1.76381 11.5893 2.08924L6.58928 7.08924C6.26384 7.41468 5.7362 7.41468 5.41077 7.08924L0.410765 2.08924C0.0853277 1.76381 0.0853277 1.23617 0.410765 0.910734Z"
              fill=""
            ></path>
          </svg>
          <img
            className="w-12 rounded-full"
            src={require("./../../assets/images/user.png")}
            alt="User"
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
